export default __webpack_public_path__ + "static/media/Xlsx.83d7df80.svg";